module.exports = __webpack_public_path__ + "static/environics-analytics-logo-2d11b7c7cfecd39f033681f46383f85a.jpg";